<template>
    <div class="message-page">
        <top-bar :topbarList="topbarList"></top-bar>
        <router-view></router-view>
    </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

export default {
    data() {
        return {};
    },
    computed: {
        topbarList() {
            let topbarList = [
                {
                    name: "消息中心",
                    isActive: false,
                    path: "/message",
                    childrenPath: [
                        "/message/info"
                    ]
                },
            ];
            topbarList.forEach(val => {
                if (val.path == this.$route.path) {
                    val.isActive = true;
                }
                if (val.childrenPath) {
                    if (~val.childrenPath.indexOf(this.$route.path)) {
                        val.isActive = true;
                    }
                }
            });
            return topbarList;
        }
    },
    components: {
        topBar
    }
};
</script>

<style lang="less" scoped>
.message-page {
    height: 100%;
}
</style>
